import { Pipe, PipeTransform } from '@angular/core';
import { getSubscriptionNameById } from '@app/utilities/subscription.utilities';

@Pipe({
  name: 'subscriptionName',
  standalone: false,
})
export class SubscriptionNamePipe implements PipeTransform {
  /**
   * Transform a subscription id to return subscription display name
   * @param subscriptionId - Course subscription id used to check if the user has this subscription
   * @returns - Subscription display name by a given subscription id
   */
  transform(subscriptionId: number): string {
    return getSubscriptionNameById(subscriptionId);
  }
}
